export class AppConfig {
    public readonly apiUrl = 'http://web.docker-fin.6f1f7237.svc.dockerapp.io:8000';
};



// WEBPACK FOOTER //
// ./src/app/app.config.ts